import Swal from 'sweetalert2'

function Confirm(config) {
  const title = config?.title ?? 'Are you sure?'
  const text = config?.text ?? ''
  const confirmButtonText = config?.confirmButtonText ?? 'Yes'
  const cancelButtonText = config?.cancelButtonText ?? 'No'
  const defaultConfig = {
    title: title,
    html: text,
    confirmButtonText: confirmButtonText,
    cancelButtonText: cancelButtonText,
    icon: 'question',
    showCancelButton: true
  }
  return Swal.fire(defaultConfig)
}

export { Confirm }
